export const normalizeInterpretationBasis = (value) => (value === "average" || value === "percentage") ? value : "raw_score";

// Low / moderate / high on the 0–100 percentage of each dimension's possible range.
// Touching bounds are fine: a score on a boundary takes the first (lower) range.
export const THREE_BAND_PERCENT_RANGES = [
  { code: "low", min: 0, max: 40, label_id: "Rendah", label_en: "Low" },
  { code: "mid", min: 40, max: 60, label_id: "Sedang", label_en: "Moderate" },
  { code: "high", min: 60, max: 100, label_id: "Tinggi", label_en: "High" },
];

/** Give every dimension that has no ranges yet the three percentage bands. Existing ranges are kept. */
export function fillEmptyDimensionsWithPercentBands(scoring = {}, dimensions = []) {
  const criteria = [...(scoring.criteria || [])];
  let filled = 0;
  for (const dimension of dimensions) {
    const index = criteria.findIndex((criterion) => criterion.dimension_id === dimension.id);
    if (index >= 0 && (criteria[index].ranges || []).length > 0) continue;
    const ranges = THREE_BAND_PERCENT_RANGES.map((range) => ({
      ...range, interpretation_id: "", interpretation_en: "", recommendation_id: "", recommendation_en: "",
    }));
    const criterion = { ...(index >= 0 ? criteria[index] : { dimension_id: dimension.id }), interpretation_basis: "percentage", ranges };
    if (index >= 0) criteria[index] = criterion;
    else criteria.push(criterion);
    filled += 1;
  }
  return { scoring: { ...scoring, criteria }, filled };
}

export function setDimensionScoreStep(scoring = {}, dimensionId, scoreStep) {
  const criteria = [...(scoring.criteria || [])];
  const index = criteria.findIndex((criterion) => criterion.dimension_id === dimensionId);
  const criterion = index >= 0 ? { ...criteria[index] } : { dimension_id: dimensionId, ranges: [] };
  if (scoreStep === "auto") delete criterion.score_step;
  else criterion.score_step = scoreStep;
  if (index >= 0) criteria[index] = criterion;
  else if (scoreStep !== "auto") criteria.push(criterion);
  return { ...scoring, criteria };
}

export function setDimensionInterpretationBasis(scoring = {}, dimensionId, basis) {
  const criteria = [...(scoring.criteria || [])];
  const index = criteria.findIndex((criterion) => criterion.dimension_id === dimensionId);
  const interpretation_basis = normalizeInterpretationBasis(basis);
  if (index >= 0) criteria[index] = { ...criteria[index], interpretation_basis };
  else criteria.push({ dimension_id: dimensionId, interpretation_basis, ranges: [] });
  return { ...scoring, criteria };
}

export function removeDimensionScoringReferences(scoring = {}, dimensionId) {
  return {
    ...scoring,
    criteria: (scoring.criteria || []).filter((criterion) => criterion.dimension_id !== dimensionId),
    norms: (scoring.norms || []).filter((norm) => norm.dimension_id !== dimensionId),
  };
}
